import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShiftType } from 'src/app/main-shared/class-models/common';
import { environment } from 'src/environments/environment';
import { CrusherMaintenanceModel, PrestartChecklistModel } from './um-maintenance';
import { ApiResponse } from 'src/app/main-shared/class-models/ApiResponse';

@Injectable({
  providedIn: 'root'
})
export class UmMaintenanceService {

  baseUrl?: string = '';
  constructor(private http: HttpClient) {
    this.baseUrl = environment.BASE_URL;
  }
  
  GetCurrentShiftDetails(unitId: any): Observable<ShiftType[]> {
    return this.http.get<ShiftType[]>(this.baseUrl + "Common/GetCurrentShift?unitId=" + unitId);
  }
  GetCurrentShiftDetailsByDateShift(unitId: any , date : any, shift: any): Observable<ShiftType[]> {
    return this.http.get<ShiftType[]>(
      this.baseUrl + "Common/GetCurrentShift?unitId=" + unitId + "&date=" + date + "&shift=" + shift 
    );
  }

  GetAllShiftDetails(): Observable<ShiftType[]> {
    return this.http.get<ShiftType[]>(this.baseUrl + "Common/GetShiftTypes");
  }

  // Prestart checklist API calls
  GetPreStartChecklistDetails(date: any, shiftName: any, unitId: any): Observable<any> {
    return this.http.get<PrestartChecklistModel[]>(this.baseUrl + "EquipmentPreStartChecklistDetail/GetEquipmentPreStartChecklistDetailV3?date=" + date + "&shiftName=" + shiftName + "&unitId=" + unitId);
  }

  GetMaintenanceBreakdownDetails(inputData: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "EquipmentMaintenanceNew/GetEquipmentMaintenanceNewByFilter", inputData);
  }

  GetMaintenanceBreakdownMasterDetails(unitId: any): Observable<any> {
    return this.http.get<any>(this.baseUrl + "EquipmentMaintenanceNew/GetMaintenanceBreakdownMasterDetails?unitId=" + unitId);
  }

  SaveMaintenanceBreakdownDetails(formData): Observable<any> {
    return this.http.post<any>(this.baseUrl + "EquipmentMaintenanceNew/SaveEquipmentMaintenanceNew", formData);
  }

  EditMaintenanceBreakdownDetails(formData): Observable<any> {
    return this.http.post<any>(this.baseUrl + "EquipmentMaintenanceNew/SaveEquipmentMaintenanceNew", formData);
  }

  DeleteMaintenanceBreakdownDetails(formData): Observable<any> {
    return this.http.delete<any>(this.baseUrl + "EquipmentMaintenanceNew/DeleteEquipmentMaintenanceNew?ids=" + formData);
  }
  // Crusher Maintenance New API Calls
  GetCrusherMaintenanceDetails(inputData: any): Observable<any> {
    return this.http.post<CrusherMaintenanceModel[]>(this.baseUrl + "EquipmentMaintenanceNew/GetCrusherMaintenanceByFilter", inputData);
  }

  SaveCrusherMaintenanceDetails(data): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl + "EquipmentMaintenanceNew/SaveCrusherMaintenance", data);
  }

  EditCrusherMaintenanceDetails(data): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl + "EquipmentMaintenanceNew/SaveCrusherMaintenance", data);
  }

  DeleteCrusherMaintenanceDetails(ids: string): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(this.baseUrl + "EquipmentMaintenanceNew/DeleteCrusherMaintenance?ids=" + ids);
  }

  GetCrusherMasterDetails(unitId: any): Observable<any> {
    return this.http.get<any>(this.baseUrl + "Common/GetCrusherTypes?unitId=" + unitId);
  }

  GetAllEquipmentStatusDetailsCount(unitId: any){
    return this.http.get<any>(this.baseUrl + "EquipmentMaintenanceNew/GetAllEquipmentStatusDetailsByType?unitId=" + unitId);
  }


}
